const storageKey = 'AUTH0_AUTH';
const fallbackStorageKey = Object.keys(localStorage).find(x => x.startsWith('@@auth0spajs@@'));

/**
 * @return {{accessToken?: string, auth0Profile?: Record<string, any>}}
 */
export function getAuth0Storage() {
    let rawAuthData;
    let authData = {};
    try {
        rawAuthData = localStorage.getItem(storageKey) ?? localStorage.getItem(fallbackStorageKey);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Failed while reading ${storageKey}:\n${error}`);
    }
    try {
        authData = JSON.parse(rawAuthData);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Failed while parsing ${storageKey} data: ${rawAuthData} `);
    }
    return authData;
}

/**
 * @param {{accessToken: string, auth0Profile: Record<string, any>}} authData
 */
export function setAuth0Storage(authData) {
    try {
        localStorage.setItem(storageKey, JSON.stringify(authData));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Failed while writing ${storageKey}:\n${error}`);
    }
}

/**
 * @return {void}
 */
export function removeAuth0Storage() {
    try {
        localStorage.removeItem(storageKey);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Failed while removing ${storageKey}:\n${error}`);
    }
}



// WEBPACK FOOTER //
// ./auth0_storage.js